import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import classnames from "classnames";
import {
  registrationFieldUpdate,
  postEventProfileFieldValidate,
  registrationPostEvent,
  EXPECTED_HOURS_OPTIONS,
} from "redux/ducks/Registration";
import zipcodes from "zipcodes";
import { optionsForEnum } from "helpers/enums";

const transformToNumber = (value) =>
  Number.isNaN(parseInt(value)) ? null : parseInt(value);

const PostEventProfile = ({
  history,
  updateField,
  location,
  professions,
  eventSettings,
  user,
  validateField,
  validation,
  contractSubmit,
  states,
  registrationPostEvent,
}) => {
  const onFieldValidate = (field) => {
    validateField(field);
  };

  const onPrevious = (e) => {
    e.preventDefault();

    if (user.postEventMasterType === "contract") {
      history.push("/");
    } else {
      history.push("/sign-up/post-event/account");
    }
  };

  const onNext = (e) => {
    e.preventDefault();
    if (user.postEventMasterType === "contract") {
      history.push("/sign-up/contract/info");
    } else {
      window.grecaptcha.ready(function() {
        console.log('grecaptcha ready');
        window.grecaptcha.execute(process.env.REACT_APP_RECAPTCHA_SITE_KEY_V3, {action: 'signup_eo'}).then(function(token) {
          updateField("token", token);
          registrationPostEvent(history, location.pathname);
        });
      });
    }
  };

  const onFieldChange = (field, triggerValidate, transformer) => {
    return (ev: SyntheticInputEvent<HTMLInputElement>) => {
      const {
        currentTarget: { value },
      } = ev;

      updateField(field, transformer ? transformer(value) : value);
      if (triggerValidate) {
        onFieldValidate(field);
      }
    };
  };

  const onZipCodeChange = (ev: SyntheticInputEvent<HTMLInputElement>) => {
    const location = zipcodes.lookup(ev.currentTarget.value);
    updateField("addressZip", ev.currentTarget.value);
    onFieldValidate("addressZip");
    if (location?.city) {
      updateField("city", location.city);
      onFieldValidate("city");
    }
    if (location?.state) {
      updateField("state", location.state);
      onFieldValidate("state");
    }
  };

  return (
    <div className="postEvent">
      <form id="accountForm" noValidate>
        <div className="form-group">
          <label className="required" htmlFor="companyName">
            Organization Name
          </label>
          <input
            type="text"
            placeholder="Bayside High School"
            value={user.companyName}
            className={classnames("form-control", {
              "is-invalid": validation.errors.companyName,
            })}
            name="companyName"
            onChange={onFieldChange("companyName")}
            onBlur={onFieldValidate.bind(this, "companyName")}
          />
          <div className="invalid-feedback">
            {validation.errors.companyName}
          </div>
        </div>
        <div className="form-group">
          <label className="required" htmlFor="street">Street Address</label>
          <input
            type="text"
            placeholder="Main Street"
            value={user.street}
            className={classnames("form-control", {
              "is-invalid": validation.errors.street,
            })}
            name="street"
            onChange={onFieldChange("street")}
            onBlur={onFieldValidate.bind(this, "street")}
          />
          <div className="invalid-feedback">{validation.errors.street}</div>
        </div>

        <div className="form-group">
          <label className="required" htmlFor="city">
            City
          </label>
          <input
            type="text"
            placeholder="Los Angeles"
            value={user.city}
            className={classnames("form-control", {
              "is-invalid": validation.errors.city,
            })}
            name="city"
            onChange={onFieldChange("city")}
            onBlur={onFieldValidate.bind(this, "city")}
          />
          <div className="invalid-feedback">{validation.errors.city}</div>
        </div>

        <div className="row">

          <div className="form-group">
            <label className="required" htmlFor="state">
              State
            </label>
            <select
              name="state"
              className={classnames("form-control", "custom-select", {
                "is-invalid": validation.errors.state,
                empty: !user.state,
              })}
              value={user.state}
              onChange={onFieldChange("state")}
              onBlur={onFieldValidate.bind(this, "state")}
            >
              <option value="" selected disabled>
                CA
              </option>
              {states.map((state, index) => {
                return (
                  <option key={index} value={state.abbreviation}>
                    {state.abbreviation}
                  </option>
                );
              })}
            </select>
            <div className="invalid-feedback">{validation.errors.state}</div>
          </div>

          <div className="form-group">
            <label className="required" htmlFor="addressZip">
              Zip Code
            </label>
            <input
              type="text"
              placeholder="90210"
              value={user.addressZip}
              className={classnames("form-control", {
                "is-invalid": validation.errors.addressZip,
              })}
              name="addressZip"
              onChange={onZipCodeChange}
              onBlur={onFieldValidate.bind(this, "addressZip")}
            />
            <div className="invalid-feedback">{validation.errors.addressZip}</div>
          </div>

        </div>

        <hr />

        <div className="form-group">
          <label className="required" htmlFor="organization">
            Organization type
          </label>
          <select
            className={classnames("form-control", "custom-select", {
              "is-invalid": validation.errors.defaultEventSettingId,
              empty: user.defaultEventSettingId === undefined || user.defaultEventSettingId === "",
            })}
            name="organization"
            value={
              user.defaultEventSettingId !== null
                ? user.defaultEventSettingId
                : ""
            }
            onChange={onFieldChange(
              "defaultEventSettingId",
              true,
              transformToNumber
            )}
            onBlur={onFieldValidate.bind(this, "defaultEventSettingId")}
          >
            <option value="" selected disabled>Pick type</option>
            {optionsForEnum(eventSettings)}
          </select>
          <div className="invalid-feedback">
            {validation.errors.defaultEventSettingId}
          </div>
        </div>

        <div className="form-group">
          <label className="required" htmlFor="expectedYearlyStaffedHours">
            How many hours do you staff healthcare providers in a year?
          </label>
          <select
            name="expectedYearlyStaffedHours"
            className={classnames("form-control", "custom-select", {
              "is-invalid": validation.errors.expectedYearlyStaffedHours,
              empty: !user.expectedYearlyStaffedHours,
            })}
            value={user.expectedYearlyStaffedHours || ""}
            onChange={onFieldChange("expectedYearlyStaffedHours", true)}
            onBlur={onFieldValidate.bind(this, "expectedYearlyStaffedHours")}
          >
            <option value="" disabled></option>
            {EXPECTED_HOURS_OPTIONS.map((option, index) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          <div className="invalid-feedback">
            {validation.errors.expectedYearlyStaffedHours}
          </div>
        </div>

        <div className="actions">
          <button
            type="button"
            className="btn btn-primary bold-button"
            onClick={onPrevious}
          >
            Previous
          </button>
          <button
            type="submit"
            className="btn btn-danger bold-button"
            disabled={!validation.valid}
            onClick={onNext}
          >
            Next
          </button>
        </div>
      </form>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    user: state.registration.user,
    validation: state.registration.postEventProfileValidation,
    states: state.enums.usStates,
    professions: state.enums.professions,
    eventSettings: state.enums.eventSettings,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateField: (field, value) =>
      dispatch(registrationFieldUpdate(field, value)),
    validateField: (field) => dispatch(postEventProfileFieldValidate(field)),
    registrationPostEvent: (history, location) =>
      dispatch(registrationPostEvent(history, location)),
  };
}

export { PostEventProfile };

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PostEventProfile)
);
